module.exports = __webpack_public_path__ + "img/CY120004.7cb4a6d1.png";